import CandidateTable from "#candidate/pages/CandidateTable"
import AccordionMain from "#core/components/accordion/Accordion"
import { useVacanteRedux } from "#vacancy/redux/slice"
import { useState } from "react"
import VacancyDetailsSalary from "./VacancyDetailsSalary"

export default function VacancyDetailsAccordion({ vacancy, refresh }) {
	const { vacancyId } = useVacanteRedux()
	const [select, setSelect] = useState(false)

	return (
		<AccordionMain
			items={[
				{ id: "salary", label: "SUELDO", component: <VacancyDetailsSalary /> },
				{
					id: "candidates",
					label: "CANDIDATOS",
					component: (
						<CandidateTable vacancyId={vacancyId} autoFetch={select === "candidates"} />
					),
				},
			]}
			getSelect={setSelect}
		/>
	)
}
